import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";

export class BaseMiniPopUpControl {
  constructor(options) {
    this.id = options.id;
    this.formId = this.id + "_form";
    this.template = options.template || "tmpl/controls/miniPopUp.html";
    this.buttonId = options.buttonId;
    this.openEvent = options.openEvent;
    this.saveEvent = options.saveEvent;
    this.saveResponseEvent = options.saveResponseEvent;
    this.title = options.title;
    this.showHeader = options.showHeader;
    this.requiresLogin =
      options.requiresLogin != undefined ? options.requiresLogin : true;
    this.autoClose = options.autoClose;
    this.timeToClose = options.timeToClose || 2000;
    this.autoCloseTimer;
    this.closeTimer;
    this.hasBeenBound = false;
    this.allowsBlankValues = options.allowsBlankValues || false;
    this.focusInputs =
      options.focusInputs != undefined ? options.focusInputs : true;
    this.openingElement;
    this.isOpen = false;
    this.removeListenerFunctions = [];
    this.addListeners();
    
  }
  preLoadData(callback) {
    callback();
  }
  openPopUp(element) {
    var _this = this;

    LoginClientManager.promptIfNotLoggedIn(
      function (user) {
        _this.preLoadData(function () {
          _this.render(element, user);
        });
      },
      function (isAuthed) {
        if (!isAuthed) {
          // _this.openingElement.removeClass(
          //   LS2PAC_CONSTANTS.CssClasses.disabled
          // );
        }
      }
    );
  }
  setUpAutoClose() {
    var _this = this;
    clearTimeout(this.autoCloseTimer);
    if (this.autoClose) {
      this.autoCloseTimer = setTimeout(function () {
        _this.closePopUp();
      }, _this.timeToClose);
    }
  }
  render(element, user) {
    var _this = this;

    this.currentElement = element;

    TemplateEngine.fetch(
      _this.template,
      $("#" + LS2PAC_CONSTANTS.Ids.mainPage),
      _this,
      function () {
        _this.initControls();
        if (_this.showHeader) {
          $("#" + _this.id)
            .find("header")
            .show();
        } else {
          $("#" + _this.id)
            .find("header")
            .hide();
        }
        _this.addInternalEvents(); //TODO why do we or re-delegate and re-bind every time a mini pop up is opened.
        _this.beforePosition();
        _this.positionPopUp(element);
        _this.checkUser(user);
        _this.afterOpen();
        _this.setUpAutoClose();
      }
    );
  }
  checkUser(user) {}
  afterOpen() {}
  beforePosition() {}
  initControls() {}
  positionPopUp(element) {
    this.repositionPopUp(element);
    this.isOpen = true;
    if (this.focusInputs) {
      $("#" + this.formId)
        .find("input:text")
        .trigger("focus");
    }
  }
  repositionPopUp(element) {
    //element
    var popUp = $("#" + this.id);

    var top = element.offset().top - popUp.height() + element.height(),
      leftEdge = element.offset().left,
      popUpWidth = $(popUp).width(),
      windowWidth = $(window).width();

    if (leftEdge + popUpWidth >= windowWidth) {
      popUp.css("left", "auto");
      popUp.css("right", windowWidth - (leftEdge + element.width()) + "px");
    } else {
      popUp.css("left", leftEdge - 20 + "px"); // -20 to add a buffer from the edge
    }
    popUp.css("top", (top < 0 ? top * -1 : top) + "px");
    popUp.show();
  }
  closePopUp() {
    var _this = this;
    if (this.isOpen) {
      this.closeTimer = setTimeout(function () {
        _this.isOpen = false;
        const element = $("#" + _this.id);
        element.fadeOut(function () {
          _this.removeAllEvents();
          element.remove();
          if (_this.openingElement) {
            // _this.openingElement.removeClass(
            //   LS2PAC_CONSTANTS.CssClasses.disabled
            // );
          }
        });
      }, 200);
    }
  }
  addInternalEvents() {
    var _this = this;

    //TODO this is baaaad
    $("#" + this.id).on("mouseup, mouseover", function () {
      clearTimeout(_this.autoCloseTimer);
      setTimeout(function () {
        clearTimeout(_this.closeTimer);
      }, 100);
    });

    $("#" + this.id).on("mouseleave", function () {
      _this.setUpAutoClose();
      return false;
    });

    $("#" + this.formId).on("mouseup", function () {
      setTimeout(function () {
        clearTimeout(_this.closeTimer);
      }, 100);
    });

    $("#" + this.formId).on("submit", function () {
      if (
        $("#" + _this.formId)
          .find("input:text")
          .val() != "" ||
        _this.allowsBlankValues
      ) {
        //TODO this seems flimsy
        if (_this.hasValidFormData()) {
          _this.formSubmit();
          _this.closePopUp();
        }
      }
      return false;
    });

    if (this.hasBeenBound == false) {
      $(document).on("mouseup", function (event) {
        if (_this.isOpen) {
          _this.closePopUp();
        }
      });
      this.hasBeenBound = true;
    }

    this.addEvents(this); //TODO there is no addEvents in base, investigate if subclasses implement
  }
  removeInternalEvents() {
    $("#" + this.id).off("mouseup mouseover");
    $("#" + this.id).off("mouseleave");
    $("#" + this.formId).off("mouseup");
    $("#" + this.formId).off("submit");
    $(document).off("mouseup");
    this.hasBeenBound = false;
  }
  //override me
  formSubmit() {}
  //override me
  addExtraListeners() {}
  addEvents(){}
  removeEvents(){}
  //override me
  hasValidFormData() {
    return true;
  }
  setPassedEventData(event) {}
  addListeners() { 
    var _this = this;

    //TODO refactor? or at least check if the buttonId is in use/visible
    const opmrGuid = TLCEventManager.addListener(
      TLC_CONSTANTS.Events.onPagingModelResponse,
      function (event) {
        $("#" + _this.buttonId).removeClass(
          LS2PAC_CONSTANTS.CssClasses.disabled
        );
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(TLC_CONSTANTS.Events.onPagingModelResponse, opmrGuid));

    const openGuid = TLCEventManager.addListener(this.openEvent, function (event) {
      clearTimeout(_this.closeTimer);
      if (_this.isOpen) {
        _this.closePopUp();
      }

      const element = event.element ? $(event.element) : event.element;

      if (element) {
        _this.openingElement = element;
        // event.element.addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      }

      if (event.responseCallback) {
        _this.responseCallback = event.responseCallback;
      } else {
        _this.responseCallback = null;
      }

      _this.setPassedEventData(event);

      if (_this.requiresLogin) {
        _this.openPopUp(element); //TODO rename
      } else {
        _this.render(element);
      }
    });
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(this.openEvent, openGuid));

    const searchGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSearch,
      function (event) {
        _this.closePopUp();
        $("#" + _this.buttonId).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onSearch, searchGuid));

    const advancedGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        $("#" + _this.buttonId).addClass(LS2PAC_CONSTANTS.CssClasses.disabled);
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch, advancedGuid));


    const logoutGuid = TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.closePopUp();
        $("#" + _this.buttonId).removeClass(
          LS2PAC_CONSTANTS.CssClasses.disabled
        );
      }
    );
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(LS2PAC_CONSTANTS.Events.onLogoutResponse, logoutGuid));

    this.addExtraListeners(this);
  }
  removeListeners(){
    this.removeListenerFunctions.forEach((remove) => remove());
  }
  // This should be called internally on close
  removeAllEvents(){
    this.removeInternalEvents();
    this.removeEvents();
  }
  // This should be called externally when the instance is destroyed
  cleanup(){
    this.removeListeners(); 
    this.removeAllEvents();
  }
}
